var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"520b16380166d234ac8a7c6e62e73a53bddaf8c3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tedinet-front@brisk-jp"]={id:"520b16380166d234ac8a7c6e62e73a53bddaf8c3"};
      